import composeRoute from "@/api/routes/utils/route-utils/route-utils";
import useWorkspaceId from "@/hooks/useWorkspaceId";
import { HOME_ROUTE } from "@/routing/app-routes";
import { Navigate } from "react-router-dom";

const RedirectToHome = () => {
  const { workspaceId } = useWorkspaceId();
  if (!workspaceId) return null;
  return (
    <Navigate to={composeRoute(HOME_ROUTE, [workspaceId])} replace={true} />
  );
};

export default RedirectToHome;
